"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Index = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _position = _interopRequireDefault(require("../utilities/position/"));
var _toolTipModule = _interopRequireDefault(require("./toolTip.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Index = exports.Index = /*#__PURE__*/function (_Component) {
  function Index(props) {
    var _this;
    _classCallCheck(this, Index);
    _this = _callSuper(this, Index, [props]);
    _defineProperty(_this, "hide", function () {
      _this.setState({
        visible: false
      });
    });
    _defineProperty(_this, "show", function () {
      _this.setPosition(true);
    });
    _defineProperty(_this, "toggle", function () {
      if (_this.state.visible) {
        _this.setState({
          visible: false
        });
      } else {
        _this.setPosition(true);
      }
    });
    _defineProperty(_this, "getEventOptions", function () {
      return _this.document.querySelectorAll("[data-seteventkey]");
    });
    _defineProperty(_this, "setEventKey", function (e) {
      _this.setActive(e.target.getAttribute("data-seteventkey"));
      _this.setEventListener();
    });
    /**
     * show on mouse over
     * if show is set to hover
     */
    _defineProperty(_this, "handleMouseOver", function () {
      _this.setPosition();
      var show = _this.props.show;
      if (show === "hover") {
        _this.show();
      }
    });
    /**
     * hide on mouse over
     * if show is set to hover
     */
    _defineProperty(_this, "handleMouseOut", function () {
      var show = _this.props.show;
      if (show === "hover") {
        _this.hide();
      }
    });
    _defineProperty(_this, "handleClickOutside", function (event) {
      // Toggle the tooltip if the click/touch event was on the target.
      if (_this.isCurrentPropTargetEvent(event)) {
        return _this.toggle();
      }

      // Close the tooltip if the click/touch event was outside the current tooltip.
      if (_this.isNotCurrentContentEvent(event)) {
        _this.hide();
      }
    });
    _defineProperty(_this, "isHorizontalScrolling", function (event) {
      return event.detail === "horizontal";
    });
    _defineProperty(_this, "handleScrollEvent", function (event) {
      _this.setPosition();
      if (_this.isHorizontalScrolling(event)) {
        _this.hide();
        _this.setExit();
      }
    });
    _defineProperty(_this, "setEntered", function () {
      _this.setPosition();
      _this.setEventListener();
    });
    _defineProperty(_this, "setExit", function () {
      _this.removeEventListener();
    });
    _defineProperty(_this, "getXYFromPosition", function () {
      var x = 0;
      var y = 0;
      if (_this.state.position.x && !isNaN(_this.state.position.x)) {
        x = _this.state.position.x;
      }
      if (_this.state.position.y && !isNaN(_this.state.position.y)) {
        y = _this.state.position.y;
      }
      return {
        x: x,
        y: y
      };
    });
    _defineProperty(_this, "isTopOrBottomType", function () {
      return !["Right", "Left"].includes(_this.props.position);
    });
    _defineProperty(_this, "getArrowOverridePosition", function (overriddenPosition) {
      var _this$props$target;
      // Do not override the position of the arrow pointer if the main tooltip
      // position hasn't been manipulated to shift it back on screen.
      // Or if the current target isn't set.
      if (!overriddenPosition || !((_this$props$target = _this.props.target) !== null && _this$props$target !== void 0 && _this$props$target.current)) {
        return null;
      }
      var left = null;
      var targetPos = _this.props.target.current.getBoundingClientRect();

      // If the current content is > 0 in the DOM, cancel it out from the arrow position.
      var otherPos = _this.position.content.position;
      var reduceBy = 0;
      if (otherPos.x > 1) {
        reduceBy = otherPos.x;
      }
      switch (_this.props.position) {
        case "Right":
        case "Left":
          // For left & right use the default position.
          left = null;
          break;
        case "Top":
        case "Bottom":
          left = targetPos.width / 2 + targetPos.x - reduceBy;
          break;
        case "BottomRight":
          left = targetPos.width + targetPos.x - 20 - reduceBy;
          break;
        case "TopLeft":
          left = targetPos.x + 20 - reduceBy;
          break;
      }
      return left;
    });
    _defineProperty(_this, "getArrowStyleToOverrideX", function () {
      if (_this.state.arrowPosition > 0) {
        return {
          left: _this.state.arrowPosition
        };
      }
      return {};
    });
    _this.state = {
      activeKey: _this.props.defaultActiveKey,
      hasTarget: false,
      visible: false,
      width: "auto",
      height: "auto",
      position: {},
      arrowPosition: null
    };
    _this.toolTip = /*#__PURE__*/_react["default"].createRef();
    _this.content = /*#__PURE__*/_react["default"].createRef();
    _this.contentContainer = /*#__PURE__*/_react["default"].createRef();
    _this.window = window;
    _this.document = document;
    _this.navigator = navigator;
    _this.isTouchDevice = "ontouchstart" in _this.window || _this.navigator.msMaxTouchPoints;
    _this.position = new _position["default"]();
    _this.position.setType("fixed");
    _this.position.setRelativePosition(_this.props.position);
    return _this;
  }
  _inherits(Index, _Component);
  return _createClass(Index, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.window.addEventListener("resize", this.setEntered);
      this.window.addEventListener("scroll", this.handleScrollEvent);
      ["click", "touch"].forEach(function (evt) {
        return _this2.window.addEventListener(evt, function (event) {
          _this2.handleClickOutside(event);
        });
      });
      if (!this.isTouchDevice) {
        this.addHoverEvent();
      }
      if (this.props.show === "alwaysOn") {
        this.show();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      // On position change re-calc the position of the tooltip when it's currently visible.
      if (prevProps.position !== this.props.position) {
        this.position.setRelativePosition(this.props.position);
        this.setPosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      this.removeHoverEvent();
      this.setExit();
      this.window.removeEventListener("resize", this.setEntered);
      this.window.removeEventListener("scroll", this.handleScrollEvent);
      ["click", "touch"].forEach(function (evt) {
        return _this3.window.removeEventListener(evt, _this3.handleClickOutside);
      });
    }
  }, {
    key: "addHoverEvent",
    value: function addHoverEvent() {
      if (this.props.show === "hover" && this.props.target) {
        var node = this.props.target.current;
        node.addEventListener("mouseover", this.handleMouseOver);
        node.addEventListener("mouseout", this.handleMouseOut);
      }
    }
  }, {
    key: "removeHoverEvent",
    value: function removeHoverEvent() {
      var show = this.props.show;
      if (this.props.target && show === "hover") {
        var node = this.props.target.current;
        if (node) {
          node.removeEventListener("mouseover", this.handleMouseOver);
          node.removeEventListener("mouseout", this.handleMouseOut);
        } else {
          return false;
        }
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener() {
      var _this4 = this;
      this.getEventOptions().forEach(function (item) {
        item.addEventListener("click", _this4.setEventKey);
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {
      var _this5 = this;
      this.getEventOptions().forEach(function (item) {
        item.removeEventListener("click", _this5.setEventKey);
      });
    }
  }, {
    key: "isCurrentPropTargetEvent",
    value: function isCurrentPropTargetEvent(event) {
      return !!(this.props.target && this.props.target.current !== null && this.props.target.current.contains(event.target)) && this.props.show !== "alwaysOn";
    }
  }, {
    key: "isNotCurrentContentEvent",
    value: function isNotCurrentContentEvent(event) {
      return !!(this.state.visible && this.content && this.content.current !== null && !this.content.current.contains(event.target) && !event.target.getAttribute("data-seteventkey") && this.props.show !== "alwaysOn");
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.props.target && this.props.target.current && this.contentContainer && this.contentContainer.current) {
        this.position.setTarget(this.props.target);
        this.position.setContent(this.contentContainer);
        var position = this.position.getPosition();
        var viewportWidth = this.window.innerWidth;
        var newX = position.x;
        var contentWidth = this.position.content.position.width;
        var contentHeight = this.position.content.position.height;
        var arrowPosition = null;
        if (this.isTopOrBottomType()) {
          var difference = 0;
          var overriddenPosition = true;
          // If the tooltip flows off the right side of the screen, position it back on the screen.
          if (position.x + contentWidth >= viewportWidth) {
            difference = position.x + contentWidth - viewportWidth;
            newX = position.x - difference - 10;
          } else if (position.x <= 0) {
            // If the tooltip flows off the left side of the screen, position it back on the screen
            newX = 10;
          } else {
            overriddenPosition = false;
          }
          arrowPosition = this.getArrowOverridePosition(overriddenPosition, difference);

          // Set width to automatic.
          if (overriddenPosition) {
            contentHeight = "auto";
            contentWidth = "auto";
          }

          // Override width / x position to made it all fit on the screen as it's too large right now.
          if (this.position.content.position.width >= viewportWidth - 20) {
            contentWidth = viewportWidth - 20;
            newX = contentWidth - viewportWidth + 30;
          }
        }
        var newState = {
          arrowPosition: arrowPosition,
          width: contentWidth,
          height: contentHeight,
          position: _objectSpread(_objectSpread({}, position), {}, {
            x: newX
          })
        };
        if (show) {
          newState.visible = true;
        }
        this.setState(newState);
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var _this$props = this.props,
        type = _this$props.type,
        position = _this$props.position;
      return "".concat(_toolTipModule["default"].toolTipAnimation, " ").concat(_toolTipModule["default"][position], " ").concat(_toolTipModule["default"][type]);
    }
  }, {
    key: "setActive",
    value: function setActive(activeKey) {
      this.setState({
        activeKey: activeKey
      });
    }
  }, {
    key: "isActive",
    value: function isActive(eventKey) {
      return this.props.children.length === 1 || this.state.activeKey === eventKey;
    }
  }, {
    key: "getChildRef",
    value: function getChildRef(child) {
      return this.isActive(child.props.eventKey) ? this.content : null;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this6 = this;
      return _react["default"].Children.map(this.props.children, function (child) {
        var nodeRef = _this6.getChildRef(child);
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          key: child.props.eventKey,
          nodeRef: nodeRef,
          "in": _this6.isActive(child.props.eventKey),
          timeout: {
            appear: 100,
            enter: 100,
            exit: 0
          },
          onEntered: _this6.setEntered,
          onExit: _this6.setExit,
          appear: true,
          unmountOnExit: true,
          classNames: "transition-tab-fade"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: nodeRef
        }, child));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        textAlign = _this$props2.textAlign;
      var _this$state = this.state,
        visible = _this$state.visible,
        width = _this$state.width,
        height = _this$state.height;
      var className = this.getClassName();
      var _this$getXYFromPositi = this.getXYFromPosition(),
        x = _this$getXYFromPositi.x,
        y = _this$getXYFromPositi.y;

      //transition styling
      var duration = 300;
      var defaultStyle = {
        opacity: 0
      };
      var transitionStyles = {
        entering: {
          opacity: 1,
          zIndex: 15
        },
        entered: {
          opacity: 1,
          zIndex: 15
        },
        exiting: {
          opacity: 0,
          zIndex: 15,
          pointerEvents: "none"
        },
        exited: {
          opacity: 0,
          zIndex: -150,
          pointerEvents: "none"
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": visible,
        timeout: duration,
        nodeRef: this.toolTip,
        "data-testid": "tooltip-transition"
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this7.toolTip,
          "data-testid": "tooltip",
          "data-visible": _this7.state.visible,
          className: className,
          style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style), defaultStyle), transitionStyles[state]), {}, {
            left: x,
            top: y,
            height: height,
            width: width
          })
        }, /*#__PURE__*/_react["default"].createElement("div", {
          "data-testid": "arrow-outer",
          className: _toolTipModule["default"].arrowOuter,
          style: _this7.getArrowStyleToOverrideX()
        }), /*#__PURE__*/_react["default"].createElement("div", {
          "data-testid": "arrow-inner",
          className: _toolTipModule["default"].arrowInner,
          style: _this7.getArrowStyleToOverrideX()
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            overflow: "hidden",
            height: "100%"
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _toolTipModule["default"].inner,
          ref: _this7.contentContainer,
          style: {
            textAlign: textAlign
          }
        }, _this7.renderChildren())));
      });
    }
  }]);
}(_react.Component);
Index.propTypes = {
  type: _propTypes["default"].oneOf(["Default", "Notice", "Warning", "Error", "Success"]),
  position: _propTypes["default"].oneOf(["Right", "Left", "Top", "TopLeft", "Bottom", "BottomRight"]),
  show: _propTypes["default"].oneOf(["hover", "click", "alwaysOn"]),
  textAlign: _propTypes["default"].oneOf(["center", "left", "right"]),
  defaultActiveKey: _propTypes["default"].string,
  target: _propTypes["default"].object
};
Index.defaultProps = {
  type: "Default",
  position: "Right",
  show: "hover",
  textAlign: "center",
  defaultActiveKey: ""
};
var _default = exports["default"] = Index;